<template>
    <div class="bg-white">
        <div class="border-b p-4 font-bold">{{ $t('summary.skirting.title') }}</div>
        <div class="p-4">
            <table class="table">
                <tr>
                    <td>{{ sockelleisteTotalLength.toFixed(2) }}m</td>
                    <td>{{ $t('summary.skirting.totallength') }}</td>
                </tr>
                
            </table>
            <table class="table ml-3">

                <!-- Leisten -->
                <tr v-for="sockelleiste of summary.sockelleisten" :key="sockelleiste.lighted + sockelleiste.color">
                    <td>{{ Math.ceil(sockelleiste.length).toFixed(2) }}m</td>
                    <td>{{ $t('summary.skirting.body', { color: $t(sockelleiste.color), lighting: $t(sockelleiste.lighted) }) }}</td>
                </tr>
                <!-- Grundprofile -->
                <tr>
                    <td>{{ sockelleisteTotalLength.toFixed(2) }}m</td>
                    <td>{{ $t('summary.skirting.baseprofile') }}</td>
                </tr>
            </table>
        </div>

        <!-- Light -->
<!--        <div class="border-b p-4 font-bold">{{ $t('summary.lighting.title') }}</div>-->
<!--        <div class="p-4 border-b">-->
<!--            <div v-if="summary.lights.length < 1" class="italic">-->
<!--                {{ $t('summary.lighting.placeholder') }}-->
<!--            </div>-->
<!--            <table class="table">-->
<!--                <tr v-for="light of summary.lights" :key="light.color">-->
<!--                    <td>{{ light.length.toFixed(2) }}m</td>-->
<!--                    <td>{{ $t('summary.lighting.body', { color: $t(light.color) }) }}</td>-->
<!--                </tr>-->
<!--            </table>-->
<!--        </div>-->

        <!-- electronic components -->
        <div class="border-b p-4 font-bold">{{ $t('summary.other-components.title') }}</div>
        <div class="p-4">
            <table class="table">
                <!-- Netzteile (NEU: Starter-Sets) -->
                <tr class="mt-4">
                  <td>{{ summary.other.netzteile }}</td>
                  <td>{{ $tc('summary.other-components.starter-sets', summary.other.netzteile).split(' ').splice(1).join(' ') }}</td>
                </tr>

                <!-- Funkschalter -->
                <!-- <tr class="mt-4">
                  <td>{{ summary.other.funkschalter }}</td>
                  <td>{{ $tc('summary.other-components.remotes', summary.other.funkschalter).split(' ').splice(1).join(' ') }}</td>
                </tr> -->

                <!-- LED-BAND -->
                <tr>
                  <td>{{ Math.ceil(ledBandTotalLength).toFixed(2) }}m</td>
                  <td>LED-Band</td>
                </tr>
            </table>
        </div>


        <!-- moulded parts (formteile) -->
        <div class="border-b p-4 font-bold">{{ $t('summary.moulded-parts.title') }}</div>
        <div class="p-4 border-b">

            <SimpleHint>{{ $t('moulded-parts.notice' )}}</SimpleHint>

<!--            <table class="table">-->

<!--                <tr><td>{{ Math.ceil(summary.formteile.innenecken / 5) }}</td><td>{{ $t('moulded-parts.summary.inside-corners') }}</td></tr>-->

<!--                <tr class="mt-4"><td>{{ Math.ceil(summary.formteile.außenecken / 5) }}</td><td>{{ $t('moulded-parts.summary.outside-corners') }}</td></tr>-->

                <!--   <tr class="mt-4"><td>{{ summary.formteile.endkappen_links }}</td><td>{{ $tc('moulded-parts.summary.endcaps-left', summary.formteile.endkappen_links).split(' ').splice(1).join(' ') }}</td></tr>-->

                <!--                <tr class="mt-4"><td>{{ summary.formteile.endkappen_rechts }}</td><td>{{ $tc('moulded-parts.summary.endcaps-right', summary.formteile.endkappen_rechts).split(' ').splice(1).join(' ') }}</td></tr>-->

<!--                <tr class="mt-4"><td>{{ Math.ceil(summary.formteile.verbinder / 5) }}</td><td>{{ $t('moulded-parts.summary.connectors') }}</td></tr>-->
<!--            </table>-->
        </div>

    </div>
</template>

<script>
import Summary from '@/models/Summary'
import SimpleHint from '@/components/SimpleHint'
import Wall from '@/models/Wall';

export default {
    components: { SimpleHint },
    props: {
        summary: Summary
    },
    computed: {
        sockelleisteTotalLength() {
            const reducer = (accumulator, sockelleiste) => accumulator + Math.ceil(sockelleiste.length);

            let val = this.summary.sockelleisten.reduce(reducer, 0);

            return parseFloat(val);
        },

        ledBandTotalLength() {
            let length = 0;

            this.summary.sockelleisten.forEach(s => {
                if(s.lighted !== Wall.LIGHTING.NONE) {
                    length += Math.ceil(s.length);
                }
            });

            return length;
        }
    }
}
</script>